import { displayToast } from '../../components/Toaster/displayToast';
import generateHeaders from '../myHeaders';

const deleteSurvey = (
    surveyId: number,
    successMessage: string,
    errorMessage: string,
    mutate: () => void,
    selectedSchema: string,
) => {
    const url = `${process.env.REACT_APP_API_URL}/configuration/surveys/${surveyId}`;

    const requestOptions = {
        method: 'DELETE',
        headers: generateHeaders(selectedSchema),
    };

    fetch(url, requestOptions)
        .then((response) => {
            if (!response.ok) {
                displayToast(errorMessage, 'error');
            } else {
                displayToast(successMessage, 'success');
                mutate();
            }
        }).catch(() => {
            displayToast(errorMessage, 'error');
        });
};

export default deleteSurvey;
